import React, {useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../actions/JobActions"
import {loadJobs} from "../helper functions/LoadJobs";

export function JobNewList() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const dispatch = useDispatch()
    let sort = useSelector(state => state.jobSortNew);
    let search = useSelector(state => state.jobSearchNew);
  
    const [loading, setLoading] = useState(true);

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>New job list</h1>
                    <p> A list of jobs that aren't completed </p>
                </div>
                <hr/>

                <div className="dropdown">
                    <div className="dropdown-btn btn-secondary"> Sort by:</div>
                    <div className="dropdown-content">
                        <a onClick={sort => {
                            dispatch(actions.SortNew("INCOMPLETE"))
                        }}>Newest First </a>
                        <a onClick={sort => dispatch(actions.SortOld("INCOMPLETE"))}>Oldest First</a>
                        <a onClick={sort => dispatch(actions.SortAtoZ("INCOMPLETE"))}> A-Z </a>
                    </div>
                </div>

                <div className="search">
                    <input id="search-input" type="text" className="search-box"
                           placeholder="Which job are you looking for?"/>
                    <button className="search-btn btn-secondary btn"
                            onClick={search => dispatch(actions.newSearch(document.getElementById("search-input").value, "INCOMPLETE"))}> 🔍
                    </button>
                </div>

                <div className="page-break"></div>
                <br/>

                <div>
                    {loadJobs(sort, search)}
                </div>

                <div className="page-break"></div>
            </AuthenticatedTemplate>
        </div>
    );
}
